const featuredOfferPath = '/deglawy/featuredOffer';

export const getFeaturedOffers = `${featuredOfferPath}`;
export const createFeaturedOffer = `${featuredOfferPath}`;
export const updateFeaturedOffersOrder = `${featuredOfferPath}/order/switch`;

export const getFeaturedOfferId = (id: number) => `${featuredOfferPath}/${id}`;
export const updateFeatureOffer = (id: number) => `${featuredOfferPath}/${id}`;

export const getDeglawyOffers = 'deglawy/offers';
